import { useCMSPageField } from '@/cms/fields'
import { tk, useToken, verticalGap } from '@sunwebgroup/ui-components'
import useEmblaCarousel from 'embla-carousel-react'
import { useIntl } from 'react-intl'
import { styled } from 'styled-components'
import { Category } from './Category'

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  ${verticalGap('spacing_md')}

  @media ${tk('mq_desktop_md')} {
    flex-direction: column;
  }
`

const Slider = styled.div`
  overflow: hidden;
  width: calc(100% + ${tk('spacing_lg')} * 2);
  margin-left: -${tk('spacing_lg')};

  @media ${tk('mq_desktop_md')} {
    width: 100%;
    margin-left: unset;
    overflow: visible;
  }
`

export function Categories() {
  const ratingByFacility = useCMSPageField('userReviews.legacyRatingByFacility')
  const intl = useIntl()
  const [emblaRef] = useEmblaCarousel({
    dragFree: true,
    breakpoints: {
      [`${useToken<string>('mq_desktop_md')}`]: { active: false },
    },
  })

  return (
    <>
      {ratingByFacility && (
        <Slider ref={emblaRef}>
          <Wrapper>
            {ratingByFacility?.map((category, index) => (
              <Category
                key={index}
                icon={category.icon}
                score={category.score}
                label={intl.formatMessage({ id: `reviews_category_label_${category.typeId}` })}
              />
            ))}
          </Wrapper>
        </Slider>
      )}
    </>
  )
}
